// `next` chỉ được là đường dẫn trong app: bắt đầu bằng "/", không "//" (schemeless URL) và không có "\".
export function isSafeNext(value: string): boolean {
  return value.startsWith('/') && !value.startsWith('//') && !value.includes('\\');
}
